import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { useAuth } from '../../providers/auth';
import { PageBox } from '../../components/pageBox';
import { DashboardCard } from '../../components/dashboardCard';
import { FloatingAssistant } from '../../components/floatingAssistent';
import { MODULOS_SIDEBAR } from '../../components/sidebar/modulos';

export default function HomePage() {
  const { user, hasPermission, isAdmin } = useAuth();

  // Mesma lista e ordem do menu lateral (antes tinha uma cópia própria que
  // ficou sem Chat, WhatsApp e Eventos).
  const modules = MODULOS_SIDEBAR;

  // Filtra módulos baseado nas permissões
  // Não passa ação específica para mostrar módulo se tem qualquer permissão (ou sub-permissão)
  const visibleModules = modules.filter(module => {
    if (isAdmin()) return true;
    return hasPermission(module.path);
  });

  return (
    <PageBox>
      <PageHeader
        title={`Olá, ${user?.nome?.split(' ')?.[0]}`}
        subtitle={
          visibleModules.length > 0
            ? 'Esses são os módulos disponíveis para sua conta'
            : 'Você não tem acesso a nenhum módulo. Entre em contato com o administrador.'
        }
      />

      <div className="col-span-2 flex w-full flex-col gap-2 rounded-xl">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {visibleModules.map(module => (
            // Link de verdade: botão direito / Ctrl+clique abrem em nova guia.
            <Link key={module.path} to={module.path} aria-label={`Abrir ${module.name}`}>
              <DashboardCard title={module.name.toUpperCase()} value="">
                {/* Ícones da lista do menu são pequenos: aqui ficam em 40px. */}
                <div
                  className="flex items-center justify-center rounded-full p-3 [&_svg]:!size-10"
                  style={{ backgroundColor: module.bgColor }}
                >
                  {module.icon}
                </div>
              </DashboardCard>
            </Link>
          ))}
          <FloatingAssistant />
        </div>
      </div>
    </PageBox>
  );
}
